import { AcademicCapIcon, ChartBarIcon, TrophyIcon } from '@heroicons/react/24/outline'
import { Trans } from 'react-i18next'
import { useTar } from '@/modules/i18n/useTar'
import { Logo } from '../Misc/Logo'

const FEATURE_KEYS = ['realSituations', 'learnByDoing', 'personalizedFeedback'] as const

const FEATURES = [
  { icon: ChartBarIcon, key: FEATURE_KEYS[0] },
  { icon: AcademicCapIcon, key: FEATURE_KEYS[1] },
  { icon: TrophyIcon, key: FEATURE_KEYS[2] },
] as const

export const HomePageFoundations = () => {
  const { t } = useTar()

  return (
    <section className="space-y-10" aria-labelledby="foundations-heading">
      <div className="space-y-4">
        <div className="text-center space-y-3">
          <h2 id="foundations-heading" className="text-3xl font-bold text-foreground">
            <Trans i18nKey="home.whyTitle" components={{ logo: <Logo /> }} />
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            {t('home.whySubtitle')}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3">
        {FEATURES.map((feature, index) => {
          const IconComponent = feature.icon
          const numeral = String(index + 1).padStart(2, '0')
          return (
            <div
              key={feature.key}
              className="px-6 py-4 md:py-2 md:border-s md:border-border/50 md:first:border-s-0 space-y-3"
            >
              <span
                aria-hidden
                className="block font-serif text-5xl font-light leading-none tabular-nums text-accent/40"
              >
                {numeral}
              </span>
              <h3 className="flex items-baseline gap-2 text-xl font-semibold text-foreground">
                <IconComponent aria-hidden className="h-4 w-4 self-center text-accent/70" />
                {t(`home.features.${feature.key}.title`)}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {t(`home.features.${feature.key}.description`)}
              </p>
            </div>
          )
        })}
      </div>
    </section>
  )
}
